import React, { useContext } from "react";

import { Preview } from "@creatomate/preview";

import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";
import SubtitlesTabs from "./SubtitleTabs";
import SubtitlesLoader from "./SubtitlesLoader";
import VttParser from "./vtt/VttParser";

interface SubtitlesParserProps {
  availableLanguages: string[];
  activeLanguageCode?: string;
  changingLanguage: boolean;
  onLanguageChange: (language: string) => void;
  preview: Preview;
}

const SubtitlesParser: React.FC<SubtitlesParserProps> = ({
  availableLanguages,
  activeLanguageCode,
  changingLanguage,
  onLanguageChange,
  preview
}) => {
  const { data: { pendingSubtitle } } = useContext(CreatomateContext);

  return (
    <div>
      <SubtitlesTabs
        availableLanguages={availableLanguages}
        activeLanguageCode={activeLanguageCode}
        changingLanguage={changingLanguage}
        onLanguageChange={onLanguageChange}
        preview={preview}
      />
      {activeLanguageCode && (
        <VttParser preview={preview} />
      )}
      {pendingSubtitle && (
        <SubtitlesLoader />
      )}
    </div>
  );
};

export default SubtitlesParser;
